module.exports = __webpack_public_path__ + "static/media/HelveticaNowText-Medium.304b6150.otf";